import React, { useContext } from 'react'
import _ from 'lodash';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';

function ViewTaxableModalReason({ taxableReason }) {

  const setModal = useContext(ModalContext);

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  return (
    <>
      <div className="row d-flex  mb-1 px-3">
        <div className="col-12 mt-1">
          <span className="transaction-text p-0">
            <p> {taxableReason} </p>
          </span>
        </div>
      </div>
      <div className='col-12 d-flex justify-content-center mb-2'>
        <button type='button' onClick={closeModal} className='btn button-close '>
          <span className='font-weight-bold'>Close</span>
        </button>
      </div>
    </>
  )
}

ViewTaxableModalReason.defaultProps = {
  taxableReason: '',
};

ViewTaxableModalReason.propTypes = {
  taxableReason: PropTypes.string,
}

const mapStateToProps = () => ({});

const enhance = _.flowRight([withRouter, connect(mapStateToProps)]);

export default enhance(ViewTaxableModalReason);